import React from 'react';
import { Skeleton, Card } from 'antd';
import { spacing } from './tokens';

interface LoadingSkeletonProps {
  rows?: number;
  showCard?: boolean;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  rows = 5,
  showCard = true,
}) => {
  const skeleton = (
    <Skeleton active paragraph={{ rows }} title={{ width: '30%' }} />
  );

  if (showCard) {
    return <Card style={{ padding: spacing.lg }}>{skeleton}</Card>;
  }

  return skeleton;
};
